<template>
  <transition name="OutStockModalFade" appear>
    <div
      @click.self="closeOutStockModal"
      class="fixed flex items-center z-50 first-letter: h-screen w-screen bottom-0 top-0 left-0 right-0 bg-black/25"
    >
      <VForm :validation-schema="outStockFormSchema" v-slot="{ handleSubmit, resetForm }" as="div" class="w-full">
        <form
          @submit="handleSubmit($event, (values) => submitOutStockForm(values, resetForm))"
          class="w-[90%] max-w-[23rem] h-fit ml-auto mr-auto align-top flex flex-col bg-white border border-[#707070] px-5 pt-[74px] relative shadow-[0px_3px_6px_#2137567B]"
        >
          <div class="absolute right-4 top-4">
            <button
              @click="closeOutStockModal"
              type="button"
              class="z-50 text-gray-400 bg-light-silver rounded-full fill-secondary p-1"
            >
              <svg aria-hidden="true" class="w-5 h-5" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>

          <div class="flex justify-center flex-col text-center">
            <h2 class="text-2xl font-bold text-space-cadet">
              {{ $t("testDetail.outStockNotifyEmailLabel") }}
            </h2>
            <p class="mt-4 text-space-cadet text-left">
              {{ $t("testDetail.outStockPreDescription") }}
            </p>
            <p class="mt-7 text-sm text-slate-grey text-left">
              <span class="font-semibold">{{ $t("testDetail.outStockMidDescription") }}</span>
              {{ $t("testDetail.outStockPostDescription") }}
            </p>
            <div class="w-full mt-[3.4rem]">
              <BaseVTextInput id="email" name="email" type="text" placeholder="Email" />
            </div>
          </div>

          <div class="mt-5 mb-8 flex justify-center">
            <BaseButton
              class="w-full h-12 text-lg"
              :text="$t('testDetail.notifyMe')"
              type="submit"
              :loading="outStockLoading"
              iconPosition="end"
            >
              <template #icon>
                <IconsEnvelop />
              </template>
            </BaseButton>
          </div>
        </form>
      </VForm>
    </div>
  </transition>
</template>

<script setup>
import * as yup from "yup";
const snackbar = useSnackbar();
const outStockLoading = ref(false);
const { t } = useI18n();

const emit = defineEmits(["close"]);

const props = defineProps({
  productID: {
    type: Number,
    required: true,
  },
});
const closeOutStockModal = () => {
  emit("close"); // notify parent
};

//OutStockForm logic
const outStockFormSchema = yup.object({
  email: yup.string().email().required(),
});

const submitOutStockForm = async (values, resetForm) => {
  values.product = props.productID;

  try {
    outStockLoading.value = true;
    const { data: response } = await useSubscribeOutOfStock(values);
    outStockLoading.value = false;

    if (response.value?.success) {
      closeOutStockModal();
      resetForm();

      snackbar.add({
        type: "success",
        text: t("testDetail.outStockNotifySuccess"),
      });
    } else {
      snackbar.add({
        type: "error",
        text: t("testDetail.outStockNotifyGenericError"),
      });
    }
  } catch (error) {
    outStockLoading.value = false;

    if (error?.data?.message) {
      snackbar.add({
        type: "error",
        text: error.data.message,
      });
    } else {
      snackbar.add({
        type: "error",
        text: t("testDetail.outStockNotifyGenericError"),
      });
    }
  }
};
</script>
